import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Redirects URLs with a trailing slash to the same path without the trailing slash.
 * This fixes the issue where users land on e.g. /about/ when visiting via referrer
 * or after refresh (S3/CloudFront often serve directory-style paths as /path/).
 *
 * Safe with S3 + CDN (CloudFront): this is a client-side only redirect (navigate with
 * replace: true). No new HTTP request is made, so S3/CDN are not hit again—no loops.
 * Root path "/" is left unchanged.
 */
const TrailingSlashRedirect = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (pathname !== '/' && pathname.endsWith('/')) {
      const pathWithoutTrailingSlash = pathname.replace(/\/+$/, '');
      navigate(pathWithoutTrailingSlash || '/', { replace: true });
    }
  }, [pathname, navigate]);

  return null;
};

export default TrailingSlashRedirect;
